var $2bd2c84dbaab5624$exports = {};
$2bd2c84dbaab5624$exports = {
  "collapse": "\u05DB\u05D5\u05D5\u05E5",
  "expand": "\u05D4\u05E8\u05D7\u05D1"
};
export { $2bd2c84dbaab5624$exports as default };